import type { IconProps } from './types';

export const Tick = ({ size, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 1.5L5.75 9.75L2 6"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
